export interface Toast {
  type?: ToastType;
  text: string;
  buttonText?: string;
  /** Runs when the button is pressed, before the toast is dismissed (e.g. an "Undo"). */
  action?: () => void;
  duration?: number;
  disableClose?: boolean;
  testId?: string;
}

export enum ToastType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info'
}
